/**
 * The scopes a task list can be filtered by.
 *
 * Values are URL slugs — the scope is carried as a route path parameter, so
 * `/task/list/team-active` must read cleanly. Do not change a value without
 * accounting for existing bookmarks.
 */
export enum TaskListScope {
    Team = "team",
    TeamActive = "team-active",
    TeamLate = "team-late",
    Unassigned = "unassigned",
    Mine = "mine",
    MyLate = "my-late",
    PendingApproval = "pending-approval",
    Approved = "approved"
}
